class HelloBar extends HTMLElement {
  constructor() {
    super();
    this.init()
  }

  connectedCallback() {
    // Hide default yeps bar
    const style = document.createElement( 'style' )
    style.setAttribute('type','text/css')
    style.innerHTML = `[id^='yeps-'] { opacity: 0; height: 0; width: 0; visibility:hidden;}`;
    if (document.getElementById('yeps')) {
       const shadow = document.getElementById('yeps').shadowRoot
       shadow.appendChild( style )
    }
  }


  init(){

    // Disconnect observe if exist
    if (this.observer) {
        this.observer.disconnect();
    }

    this.observer = new MutationObserver(this.mutationCallBack.bind(this));
    // Observer config
    var config = {
        attributes: false,
        childList: true,
        subtree: true
    };
    const shadowRoot = document.getElementById('yeps')?.shadowRoot;

    if(shadowRoot) {
        this.observer.observe(shadowRoot, config);
    } else {
        this.hideBar()
    }
  }
    /**
    * APP Geo Targeting - Notify pop-ups
    * Check if banner type is "top of page"
    */
    isBannerTopOfPage(node) {

        if (node) {
            if (node.querySelector('.yeps-text') && node.querySelector('.yeps-text').innerHTML) {
                return true;
            }
        }

        return false;
    }

    // Add message to hellobar
    addMessageToHelloBars(message) { 
        const splideElem = document.createElement('div')
        splideElem.setAttribute('class', 'splide__slide');
        const messageElem = document.createElement('div')
        messageElem.setAttribute('class', 'hello-bar__message');
        messageElem.innerHTML = message
        splideElem.appendChild(messageElem);
        this.querySelector('.splide__list').appendChild(splideElem)
    }

    addCountdownToHelloBars(htmlButton) {
        this.querySelectorAll('.yeps-countdown-block').forEach(elem => elem.innerHTML = htmlButton)
    }

    mutationCallBack(mutations) {
        let disconnect = false;
        let exitsHelloBar = false;
        const self = this;

        mutations.forEach(function(mutation) {

            mutation.addedNodes.forEach(function(node) {
                if (node.classList.contains( "yeps-frame" )) {
                    const barId = node.getAttribute('id')
                    self.closest('.hello-bar__container').setAttribute('id', barId)
                }
                if (node.classList.contains( "yeps-bar" )) {
                    // If message is Top of Page create helloBar and remove node from dom
                    if (self.isBannerTopOfPage(node)) {
                        let geoText = '';
                        let countDown = '';
                        node.querySelectorAll('.yeps-content').forEach(function(message) {
                            // check message type, if countdown
                            if(message.querySelector('.yeps-countdown-block')) {
                                
                                self.addMessageToHelloBars(message.innerHTML);
                                setInterval(function () {
                                    countDown = message.querySelector('.yeps-countdown-block').innerHTML;
                                    self.addCountdownToHelloBars(countDown);
                                }, 1000);
                            } else {
                                geoText = message.innerHTML
                                self.addMessageToHelloBars(geoText);
                            }
                        });

                        // Hide node from dom
                        node.style.display = 'none';

                        disconnect = true;
                        exitsHelloBar = true;
                    }
                }

                if(node.nodeName == "STYLE" && node.getAttribute('type') != 'text/css') {
                    document.head.appendChild( node )
                }
            });

            if (exitsHelloBar) {
                self.querySelector('.splide').setAttribute('restart', true)
                document.querySelector('.hello-bar').classList.remove('disabled', 'md:twcss-hidden')
                exitsHelloBar = false
            }

            //Disabilito l'observer solo se una o più regole sono vere
            if (disconnect){
                self.observer.disconnect();
            }
        });
    }

    hideBar() {
        document.querySelector('.hello-bar').classList.add('md:twcss-hidden')
    }
}

if (!customElements.get('hello-bar')) {
  customElements.define(
    'hello-bar', HelloBar
  );
}